import { Board, BoardType } from "@sportactics/board-editing";

import { createBoard } from "./create-board";

export function resolveBoard(data: Board | null, boardType: BoardType): Board {
  if (data !== null) return data;
  return createBoard(boardType);
}
